import { render, staticRenderFns } from "./LogNotesList.vue?vue&type=template&id=77d0b426&"
import script from "./LogNotesList.vue?vue&type=script&lang=js&"
export * from "./LogNotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports